import { Link } from "react-router-dom";
import type { Drama } from "@/mocks/dramas";
import { episodeLabel, rankBadge } from "@/utils/drama";

type DramaCardProps = {
  drama: Drama;
  rank?: number;
};

export default function DramaCard({ drama, rank }: DramaCardProps) {
  return (
    <article className="group">
      <Link
        to={`/drama/${drama.id}`}
        className="block cursor-pointer"
        title={`${drama.title} 全集高清在线观看`}
      >
        <div className="relative aspect-[3/4] w-full overflow-hidden rounded-xl border border-foreground-50/10 bg-background-900 shadow-lg shadow-background-950/60">
          <img
            src={drama.cover}
            alt={`《${drama.title}》微短剧封面海报，${drama.year}年${drama.status}`}
            width={600}
            height={800}
            loading="lazy"
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.06]"
          />
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/10 to-transparent opacity-90" />
          <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-foreground-50/10" />

          {drama.exclusive && (
            <span className="absolute left-2 top-2 rounded-md bg-accent-500 px-1.5 py-0.5 text-[10px] font-bold tracking-wide text-background-50 shadow-md shadow-accent-950/50">
              独家
            </span>
          )}

          <span className="absolute right-2 top-2 rounded-md bg-background-950/75 px-1.5 py-0.5 text-[10px] font-medium text-foreground-100 backdrop-blur-sm">
            {drama.badge}
          </span>

          {typeof rank === "number" && (
            <span className="absolute bottom-2 left-2 rounded-md bg-primary-500 px-1.5 py-0.5 font-heading text-[11px] font-black text-background-950 shadow-md shadow-primary-950/60">
              {rankBadge(rank)}
            </span>
          )}

          <span className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-primary-500/95 text-background-950 shadow-xl shadow-background-950/70">
              <i className="ri-play-fill text-xl" aria-hidden="true" />
            </span>
          </span>

          <span className="absolute bottom-2 right-2 flex items-center gap-0.5 rounded-md bg-background-950/70 px-1.5 py-0.5 text-[11px] font-semibold text-primary-300 backdrop-blur-sm">
            <i className="ri-star-fill text-[10px]" aria-hidden="true" />
            {drama.rating.toFixed(1)}
          </span>
        </div>

        <h3 className="mt-2.5 line-2 text-sm font-medium leading-snug text-foreground-100 transition-colors group-hover:text-primary-300 md:text-[15px]">
          {drama.title}
        </h3>
        <p className="mt-1 flex items-center gap-1 text-[11px] text-foreground-500 md:text-xs">
          <span>{episodeLabel(drama)}</span>
          <span className="text-foreground-700">·</span>
          <span>{drama.views}播放</span>
        </p>
      </Link>
    </article>
  );
}